import { render, staticRenderFns } from "./InfoArticle.vue?vue&type=template&id=7f0d30b1&scoped=true"
import script from "./InfoArticle.vue?vue&type=script&lang=js"
export * from "./InfoArticle.vue?vue&type=script&lang=js"
import style0 from "./InfoArticle.vue?vue&type=style&index=0&id=7f0d30b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0d30b1",
  null
  
)

export default component.exports